import { SheetCloseOptions, SheetConfig, SheetId, SheetOpenOptions } from './sheetTypes';

export enum SheetActionTypes {
    SHEET_OPEN = 'SHEET_OPEN',
    SHEET_CLOSE = 'SHEET_CLOSE',
    SHEET_CLOSE_TRANSITION_DID_COMPLETE = 'SHEET_CLOSE_TRANSITION_DID_COMPLETE',
    SHEET_UPDATE_ACTIVE_SNAP_POINT = 'SHEET_UPDATE_ACTIVE_SNAP_POINT',
}

export type SheetOpenAction = {
    type: SheetActionTypes.SHEET_OPEN;
    sheetId: SheetId;
    instanceId?: string;
    config?: SheetConfig;
    options?: SheetOpenOptions;
};

export interface ErrorSheetOpenAction extends SheetOpenAction {
    activeErrorNoticeId: string;
    data: object | undefined;
}

export type SheetCloseAction = {
    type: SheetActionTypes.SHEET_CLOSE;
    sheetId: SheetId;
    instanceId?: string;
    options?: SheetCloseOptions;
};

export type SheetCloseTransitionCompleteAction = {
    type: SheetActionTypes.SHEET_CLOSE_TRANSITION_DID_COMPLETE;
    sheetKey: string;
};

export type SheetUpdateActiveSnapPointAction = {
    type: SheetActionTypes.SHEET_UPDATE_ACTIVE_SNAP_POINT;
    sheetId: SheetId;
    instanceId?: string;
    activeSnapPoint: number;
};

export type SheetAction =
    | SheetOpenAction
    | ErrorSheetOpenAction
    | SheetCloseAction
    | SheetCloseTransitionCompleteAction
    | SheetUpdateActiveSnapPointAction;
